import { render } from "./WelcomeParty.vue?vue&type=template&id=2e4f31cf&scoped=true"
import script from "./WelcomeParty.vue?vue&type=script&lang=js"
export * from "./WelcomeParty.vue?vue&type=script&lang=js"

import "./WelcomeParty.vue?vue&type=style&index=0&id=2e4f31cf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e4f31cf"]])

export default __exports__